import { useIntl } from "react-intl";
import { TCheckText } from "src/app/types/CheckText";
import MultiLinesChart, { TChartData } from "../MultiLinesChart/MultiLinesChart";
import { Row, Col } from "react-bootstrap";

export interface ICheckTextInfo {
    info?: TCheckText;
}

const CheckTextInfo = (props: ICheckTextInfo) => {
    const { info } = props;
    const { formatMessage } = useIntl();

    const YTGData = [];
    if (info?.YTG) {
        YTGData.push({
            type: "line",
            lineStyleColor: "#F83939",
            areaStyleColor: "#F83939",
            data: info.YTG.red,
        });
        YTGData.push({
            type: "line",
            lineStyleColor: "#FFBC40",
            areaStyleColor: "#FFBC40",
            data: info.YTG.orange,
        });
        YTGData.push({
            type: "line",
            lineStyleColor: "#A5EB97",
            areaStyleColor: "#A5EB97",
            data: info.YTG.green,
        });
        YTGData.push({
            type: "line",
            lineStyleColor: "#96C1EA",
            areaStyleColor: "#96C1EA",
            data: info.YTG.blue,
        });
        YTGData.push({
            type: "line",
            lineStyleColor: "#000",
            data: info.YTG.scores,
        });
    }
    return (
        <div className="d-flex flex-column">
            {info?.CopyScape?.error || info?.error ? (
                <div className="d-flex gap-2 text-danger">
                    <span>error:</span>
                    <span>{info?.CopyScape?.error ? info?.CopyScape?.error : info?.error}</span>
                </div>
            ) : (
                <>
                    <>
                        {info?.YTG && (
                            <>
                                <Row>
                                    <Col>
                                        <MultiLinesChart
                                            data={YTGData as Array<TChartData>}
                                            legend={[
                                                "Suroptimisation",
                                                "Optimisation forte",
                                                "Optimisation normale",
                                                "Sous-optimisation",
                                                "Votre contenu",
                                            ]}
                                        />
                                    </Col>
                                </Row>
                                <div className="d-flex align-self-center gap-2 mt-5">
                                    <b>{formatMessage({ id: "common.field.YTGScore" })}</b>
                                    <span>
                                        {info?.YTG?.score} % (
                                        {formatMessage({ id: "common.field.allowed" })}{" "}
                                        {info?.YTG.scoreAllowed}% )
                                    </span>
                                </div>
                            </>
                        )}
                    </>

                    <>
                        {info?.CopyScape && (
                            <>
                                <div className="d-flex gap-2">
                                    <b>{formatMessage({ id: "common.field.allpercentmatched" })}</b>
                                    <span>
                                        {info?.CopyScape?.allpercentmatched} % (
                                        {formatMessage({ id: "common.field.allowed" })}{" "}
                                        {info?.CopyScape.allpercentmatchedAllowed}% )
                                    </span>
                                </div>
                                <div className="d-flex gap-2">
                                    <b>{formatMessage({ id: "common.field.allviewurl" })}</b>
                                    <a href={info?.CopyScape?.allviewurl} target="_blank">
                                        {info?.CopyScape?.allviewurl}
                                    </a>
                                </div>
                            </>
                        )}
                    </>
                </>
            )}
        </div>
    );
};

export default CheckTextInfo;
